
<div class="athlete-wrapper athlete-wrapper-mobile">
    <p class="mb-40 mx-1 p-title-2">
        The UK's Most Highly Rated <br/>
        by Elite Athletes.
    </p>
    <p-carousel [value]="images_slider"
                [numVisible]="1"
                [numScroll]="1"
                [circular]="true"
                [showNavigators]="false"
                [autoplayInterval]="2500">
        <ng-template let-item pTemplate="item">
            <div class="athlete-box">
                <div class="athlete-image-box">
                    <img [src]="item.imgSrc"
                         [alt]="item.name"
                         width="260"
                         height="138">
                </div>
                <div class="athlete-content mt-20">
                    <p class="mb-0 athlete-name">{{ item.name }}</p>
                    <p class="athlete-title">{{ item.title }}</p>
                    <p class="athlete-description">{{ item.description }}</p>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>

<div class="athlete-wrapper athlete-wrapper-desktop">
    <div>
        <p class="mb-5 p-title-2">The UK's Most Highly Rated by Elite Athletes.</p>
    </div>
    <swiper-container
            slides-per-view="auto"
            grab-cursor="true"
            pagination="true"
            centered-slides="true"
            class="athlete-carousel-swiper"
            loop="false"
            [attr.pagination-clickable]="true"
            [attr.init]="false"
            autoplay='{
                  "delay": 2500,
                  "disableOnInteraction": false,
                  "pauseOnMouseEnter": true
              }'
    >
        <swiper-slide *ngFor="let item of images_slider">
            <div class="athlete-box">
                <div class="athlete-image-box">
                    <img [src]="item.imgSrc"
                         [alt]="item.name"
                         width="220"
                         height="326">
                </div>
                <div class="athlete-content mt-20">
                    <p class="mb-0 athlete-name">{{ item.name }}</p>
                    <p class="athlete-title">{{ item.title }}</p>
                    <p class="athlete-description">{{ item.description }}</p>
                </div>
            </div>
        </swiper-slide>
    </swiper-container>
</div>


